import React, { Component } from "react";
import { Accordion, Icon, Form, TextArea, Header } from "semantic-ui-react";

class NoteToSelfCard extends Component {
  constructor() {
    super();
    this.state = {
      editing: false,
      activeindex: -1,
      note: ""
    };
  }
  handlekeypress(e) {
    if (e.key == "Escape") {
      this.props.patchnote(this.state.note);
      this.setState({ activeindex: -1 });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.myinfo !== null &&
      this.props.myinfo.notetoself !== this.state.note &&
      this.state.editing === false
    ) {
      console.log("Setting State");
      this.setState({ note: this.props.myinfo.notetoself });
    }
  }
  componentDidMount() {
    if (
      this.props.myinfo !== null &&
      this.props.myinfo.notetoself !== this.state.note &&
      this.state.editing === false
    ) {
      console.log("Setting State");
      this.setState({ note: this.props.myinfo.notetoself });
    }
  }
  render() {
    return (
      <Accordion fluid activeIndex={this.state.activeindex}>
        <Accordion.Title
          fluid
          as="h3"
          onClick={() => {
            if (this.state.activeindex === 0) {
              this.setState({ activeindex: -1 });
            } else {
              this.setState({ activeindex: 0 });
            }
          }}
        >
          <Header as="h3">
            <Icon name="compose" />
            Note to Self
          </Header>
          <p>{this.state.note}</p>
        </Accordion.Title>
        <Accordion.Content active={this.state.activeindex === 0}>
          <Form fluid>
            <TextArea
              value={this.state.note}
              onChange={e =>
                this.setState({ note: e.target.value, editing: true })
              }
              onBlur={() => {
                this.setState({ activeindex: -1 });
                this.props.patchnote(this.state.note);
              }}
              onKeyDown={e => this.handlekeypress(e)}
            />
          </Form>
        </Accordion.Content>
      </Accordion>
    );
  }
}
export default NoteToSelfCard;



// WEBPACK FOOTER //
// ./src/components/home-components/notetoself.js